export { default as logoTemplate } from './logo.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/controls/logo/templates/index.ts